import { Component, OnInit,ViewChild, ElementRef } from '@angular/core';
import { FastAPIService } from '../../service/fast-api.service';
import { lastValueFrom} from 'rxjs';
import { FormControl } from '@angular/forms';
import { ConfirmationService, MessageService,} from 'primeng/api';
import { Router } from '@angular/router';
import Map from "@arcgis/core/Map";
import MapView from "@arcgis/core/views/MapView";
import Zoom from '@arcgis/core/widgets/Zoom';
import Basemap from "@arcgis/core/Basemap";
import Extent from "@arcgis/core/geometry/Extent.js";
import Point from '@arcgis/core/geometry/Point';
import { MapService } from 'src/app/service/map-page.service';
import Graphic from '@arcgis/core/Graphic';
import FeatureLayer from '@arcgis/core/layers/FeatureLayer';
import SimpleRenderer from '@arcgis/core/renderers/SimpleRenderer';
import PictureMarkerSymbol from '@arcgis/core/symbols/PictureMarkerSymbol';
import GraphicsLayer from '@arcgis/core/layers/GraphicsLayer';

@Component({
  selector: 'app-estate',
  templateUrl: './estate.component.html',
  styleUrls: ['./estate.component.scss']
})
export class EstateComponent implements OnInit{
  background = "assets/web-scraping-component-images/background.svg";
  mainIcon = "assets/web-scraping-component-images/mainIcon.svg";
  toBeginningIcon = "assets/web-scraping-component-images/start.svg";
  nextIcon = "assets/web-scraping-component-images/next.svg";
  backIcon = "assets/web-scraping-component-images/back.svg";
  toLastIcon = "assets/web-scraping-component-images/last.svg";
  calenderIcon = "assets/web-scraping-component-images/calendar.svg";

  filterName: string = "";
  filterBedroom: Number = 0;
  filterBathroom: Number = 0;
  filterStatus: string = "";
  filterPrice: string = "";
  scriptSelected: FormControl = new FormControl();
  newMessage: string = '';
  scrapingTypeSelected: FormControl = new FormControl('');
  scriptStartPage: FormControl = new FormControl();
  scriptStopPage: FormControl = new FormControl();

  goto_dialog_visible: boolean = false;
  showChatPopup: boolean = false;
  sortOrder: boolean = true;
  loading: boolean = false;

  pointGraphics: Graphic[] = [];
  
  pageSize: number = 10;
  currentPage: number = 1;
  totalPage: number = 0;
  budget: number[] = [5000, 10000];
  gotoPage: number = this.currentPage;

  todayDate: Date = new Date();

  requestList: WebScrapingRequest[] = [];
  filterDataSourceOption: string[] = ["Any"];
  pageSizeList: number[] = [10, 15, 20];
  zoomWidget!: Zoom;
  lastZoom!: number;

  sortBy: number = -1;
  map: Map | null = null;
  mapView: MapView | null = null;
  messages: Array<{sender: string, text: string}> = [];
  @ViewChild('mapPanel', { static: true }) mapPanel!: ElementRef;

  constructor(private fastService: FastAPIService, private messageService: MessageService, private confirmationService: ConfirmationService, private route: Router, private mapService: MapService) {
    setInterval(() => {this.reload()}, 10000);
  }

  async ngOnInit(): Promise<void> {
    this.initializeMap();
    this.loading = true;
    await this.getRequestList();
    this.loading = false;

    this.scriptStartPage.valueChanges.subscribe((value: number) => {
      let stop: number = this.scriptStopPage.value;

      if(stop < value) stop = value;
      if(stop > value + 10) stop = value + 10;

      this.scriptStopPage.setValue(stop);
    })

    this.scrapingTypeSelected.valueChanges.subscribe((value: string) => {
      this.scriptSelected.setValue({})
    })
  }

  // map (90-163)
  initializeMap(): void {
    const basemap = new Basemap({
        portalItem: {
          id: 'bc19c34549de4000bcd91cef929420dc'
        }
      });
  
      this.map = new Map({
        basemap: basemap,
      });
  
      this.mapView = new MapView({
        container: this.mapPanel.nativeElement,
        map: this.map,
        center: [100.56971177919995, 13.730582876119216],
        zoom: 14,
        constraints: {
          minZoom: 2,
          geometry: new Extent({
            xmin: -180,
            ymin: -80,
            xmax: 180,
            ymax: 75
          })
        },
        popupEnabled: false
      });
      this.mapView.ui.move('zoom', 'top-right')
      this.mapView.when(() => {
        this.zoomWidget = new Zoom({
          view: this.mapView as __esri.MapView
        });
    
        this.mapView!.ui.remove('zoom');
        this.mapView!.ui.add(this.zoomWidget, 'top-right');
    
        let isZoomingIn = false;
    
        this.mapView!.watch('zoom', () => {
          const currentZoom = this.mapView!.zoom;
          if (currentZoom > this.lastZoom && !isZoomingIn) {
            isZoomingIn = true;
            this.zoomWidget.destroy();
            this.zoomWidget = new Zoom({
              view: this.mapView as __esri.MapView
            });
            this.mapView!.ui.add(this.zoomWidget, 'top-right');
          } else if (currentZoom < this.lastZoom && isZoomingIn) {
            isZoomingIn = false;
            this.zoomWidget.destroy();
            this.zoomWidget = new Zoom({
              view: this.mapView as __esri.MapView
            });
            this.mapView!.ui.add(this.zoomWidget, 'top-right');
          }
          this.lastZoom = currentZoom;
        });
        // this.lastZoom = this.mapView!.zoom;
      });
  }

  reload() {
    this.getRequestList();
  }

  // get data from server (170-186)
  gettingRequest: Boolean = false;
  async getRequestList(DataSource: string = "All-Source", ProjectName: string = "All-Name",PriceMax: number = 2000000, PriceMin: number = 0, Start: number = 0, Row:number = 10) {
    const response = await lastValueFrom(this.fastService.getCondoMockUpList(DataSource,ProjectName,PriceMax,PriceMin,Start,Row))
    this.totalPage = response.response.total;
    this.requestList = response.response.data.properties;

    const responsePoints = await lastValueFrom(this.fastService.getCondoMockUpList(DataSource,ProjectName,PriceMax,PriceMin,0,200))
    const pointList = await this.mapService.generateCondoPoints(responsePoints.response.data.properties)
    this.pointGraphics = await this.mapService.createGraphicsFromPointsCondo(pointList)
    this.map?.add(new GraphicsLayer({
        graphics: this.pointGraphics
      })
    )
    // this.map?.add(new FeatureLayer(
    //   {
    //     source: this.pointGraphics,
    //     renderer: new SimpleRenderer
    //   }
    // ))
  }

  // fucntion chat Ai (188-206)
  onAIChat(): void {
    this.showChatPopup = true;
  }

  closeChatPopup(): void {
    this.showChatPopup = false;
  }

  sendMessage(): void {
    if (this.newMessage.trim()) {
      this.messages.push({sender: 'User', text: this.newMessage});
      this.newMessage = '';
      //เรียกใช้ API หรือ service
      //การตอบกลับจาก AI
      setTimeout(() => {
        this.messages.push({sender: 'AI', text: 'This is a sample AI response.'});
      }, 1000);
    }
  }

  onClearClick() {
    this.filterName = "";
    this.filterBedroom = 0;
    this.filterBathroom = 0;
    this.budget = [5000, 10000];;
  }

  async onApplyClick() {
    this.loading = true;
    await this.getRequestList();
    this.loading = false;
    this.currentPage = 1;  
  }

  onSliderChange(event: any) {
  }

  onMinChange(event: any) {
    if (event.value > this.budget[1]) {
      this.budget[0] = this.budget[1];
    } else {
      this.budget[0] = event.value;
    }
    this.budget = [...this.budget];
  }

  onMaxChange(event: any) {
    if (event.value < this.budget[0]) {
      this.budget[1] = this.budget[0];
    } else {
      this.budget[1] = event.value;
    }
    this.budget = [...this.budget];
  }



  // fucntion ChangePage (224-311)

  onToBeginningClick() {
    this.currentPage = 1;
    this.getRequestList()
  }

  onPageSizeChange(event: any) {
    //console.log(event)
    //this.currentPage = Math.ceil(begin / event.value);
    this.currentPage = 1;
    this.getRequestList();
  }

  getRequestBegin() {
    return Math.min(((this.currentPage - 1) * this.pageSize), this.totalPage - 1);
  }

  getRequestEnd() {
    return Math.min(this.totalPage, this.getRequestBegin() + this.pageSize);
  }

  onBackClick() {
    this.currentPage = Math.floor(Math.max(1, this.currentPage - 1));
    this.getRequestList();
  }

  onNextClick() {
    this.currentPage = Math.min(this.currentPage + 1, Math.ceil(this.totalPage / this.pageSize));
    this.getRequestList();
  }

  onToLastClick() {
    this.currentPage = Math.ceil((this.totalPage / this.pageSize));
    this.getRequestList();
  }

  onPageChange(event: any) {
  }

  onPageNumberClick() {
    this.gotoPage = this.currentPage;
    this.goto_dialog_visible = true;
  }

  getGotoOptions() {
    let options: number[] = [];
    for(let i = 1; i <= Math.ceil(this.totalPage / this.pageSize); i++) {
      options.push(i);
    }
    return options;
  }

  onGotoClick() {
    this.currentPage = this.gotoPage;
    this.goto_dialog_visible = false;
    this.getRequestList();
  }

  goto(page: number) {
    this.currentPage = page;
    this.getRequestList();
  }

  isActiveButton(page: number): boolean {
    let length = Math.ceil(this.totalPage / this.pageSize);

    if(page <= 0 || page > length) {
      return false;
    }

    if(page == this.currentPage - 4) {
      return this.currentPage == length;
    }
    
    if(page == this.currentPage - 3) {
      return this.currentPage + 1 >= length;
    }

    if(page == this.currentPage + 4) {
      return this.currentPage == 1;
    }

    if(page == this.currentPage + 3) {
      return this.currentPage <= 2;
    }

    return true;
  }
}


export class WebScrapingRequest {

}

export class WebScrapingAttempt {

}

